import React, { useEffect, useState } from "react";
import ReactDOM from "react-dom/client";
import "./index.scss";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { Provider } from "react-redux";
import store from "./store/index";
import { BrowserRouter } from "react-router-dom";
import { ThemeProvider } from "@mui/material/styles";
import { theme } from "./theme/MUITheme";
import { TextContextProvider } from "./text/TextProvider";
import { waitForTDServerInit } from "td_server/bootstrap";
import { env } from "./env";
import HomeSkeleton from "./components/Other/HomeSkeleton";
import CleverTapService from "./utils/analyics/CleverTapService";
import {
  getBrowserFromUAData,
  getDeviceTypeFromUserAgent,
  getNetworkType,
  trackCleavertapEvent,
} from "./utils/analyics/analyticsHelper";
import { ANALYTICS_EVENTS } from "./utils/analyics/analyticsEvents";
import { LOCALSTORAGE_KEY } from "./utils/Constants";

function RootBootstrap() {
  const [isReady, setIsReady] = useState(false);

  useEffect(() => {
    const browserData = getBrowserFromUAData();
    reportWebVitals((metric: any) => {
      trackCleavertapEvent(ANALYTICS_EVENTS.WEB_VITALS_RECORDED, {
        Event_Category: "performance",
        User_ID:
          JSON.parse(localStorage.getItem(LOCALSTORAGE_KEY.USERINFO) ?? "{}")
            ?.id ?? "Guest User",
        Device_Type: getDeviceTypeFromUserAgent(),
        Network_Type: getNetworkType(),
        Browser: browserData.Browser,
        Browser_Version: browserData.Browser_Version,
        Screen_Path: window.location.pathname,
        [metric.name]: metric.value,
      });
    });
    async function init() {
      CleverTapService.init();
      try {
        await waitForTDServerInit(env as any);
      } catch (err) {
        console.error("🔥 TD Server init failed", err);
      } finally {
        // Don’t wait forever — ensure UI shows
        setIsReady(true);
      }
    }

    // Defer init to next frame to allow first paint
    requestAnimationFrame(init);
  }, []);

  if (!isReady) {
    return (
      <div className="splash-screen">
        <HomeSkeleton />
      </div>
    );
  }

  return (
    <Provider store={store}>
      <TextContextProvider>
        <ThemeProvider theme={theme}>
          <BrowserRouter>
            <App />
          </BrowserRouter>
        </ThemeProvider>
      </TextContextProvider>
    </Provider>
  );
}

const root = ReactDOM.createRoot(document.getElementById("root")!);
root.render(<RootBootstrap />);

reportWebVitals();
